export enum ExternalRoutesEnum {
    Jobs = 'https://jobsinshared.com',
}
